export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;

export const SHOP_CAROUSEL_TRIGGER_DELAY = 1000;

export const VIDEO_EXTENSIONS = ['mov', 'mp4'];

